<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <DataTableMain :datatable="table" :on-success="SuccessTableAction" :itemsAction="SuccessTableAction"/>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
import DataTableMain from '@/components/tables/DataTableMain'
// import router from '@/router'
export default {
  mixins: [Permission],
  data: () => ({
    table: {
      itemKey: 'folio',
      header: {
        options: [
          { title: 'Refrescar', icon: 'mdi-cached', color: 'primary', action: 'refreshData', code: 'libre', hidden: '' }
        ],
        titles: [
          { text: 'Cve Empleado', value: 'cve_empleado', class: 'black--text' },
          { text: 'Nombre Completo', value: 'nombre_completo', class: 'black--text' },
          { text: 'Depto. Empleado', value: 'departamento_empleado', class: 'black--text' },
          { text: 'Estatus', value: 'estatus_baja_empleado', class: 'black--text' },

          { text: 'Cantidad de Inventarios', value: 'Cantidad', class: 'black--text' },
          { text: '', value: 'ActionsGral', class: 'black--text', align: 'right' }
        ],
        loading: false,
        filter: true
      },
      body: {
        data: [],
        actions: [
          { title: 'Enviar a Trasnferencia', icon: 'mdi-checkbox-blank-circle', color: 'grey darken-3', action: 'newData', code: 'inventario.inventariables.transferencias-masivas' }
        ]
      },
      footer: {
        paging: true
      }
    },
    user: {}
  }),
  components: {
    DataTableMain
  },
  mounted () {
    this.refreshData({})
    this.ShowPermisos({ permisos: JSON.parse(localStorage.getItem('permisos')), tableMain: this.table })
  },
  methods: {
    ...mapActions(['getUrlServices', 'GETObjects']),
    ...mapMutations(['SHOW_DIALOG_MAIN']),
    SuccessTableAction (item) {
      this[item.action](item)
    },
    ExecuteUrl (url) {
      if (this.get_urls != null) {
        const router = this.get_urls[url]
        this.GETObjects({ url: router })
      } else { this.getUrlServices() }
    },
    /* *==========*==========*==========*==========*==========*==========*==========*==========* */
    refreshData (item) {
      this.table.header.loading = true
      this.ExecuteUrl('inventario.empleado-baja')
    },
    newData ({ item }) {
      const objeto = item
      objeto.indicador = 'TransferenciasEmpleadosBaja'
      this.SHOW_DIALOG_MAIN({
        type: 'create',
        with: '60%',
        title: 'Enviar a  Solicitud De Transferencia',
        body: {
          objectMain: objeto,
          paramsDialog: {
            form: this.get_EnviarInventarioGral,
            url: this.get_urls['inventario.inventariables.transferencias-masivas'],
            message: 'Registro Agregado Correctamente',
            returnObject: true,
            setmodel: true
          }
        }
      })
    }
  },
  computed: {
    ...mapGetters(['get_urls', 'get_objects', 'get_sendDataView',
      'get_EnviarInventarioGral'
    ])
  },
  watch: {
    get_urls (val) { this.refreshData({}) },
    get_objects (vals) {
      if (vals) {
        this.table.body.data = vals
        this.table.header.loading = false
      }
    },
    get_sendDataView ({ name, model }) {
      if (name === 'create') this.refreshData({})
    }
  }
}
</script>
<style>
</style>
